import { getIdTokenResult } from "firebase/auth"
import { firebaseAuth } from "./firebase"
import { logger } from "@utils/logger"

export const API_POLLING_INTERVAL_MS = 30 * 1000
export const GAPI_POLLING_INTERVAL_MS = 15 * 60 * 1000

export const ACCESS_TOKEN_QUERY_KEY = "google_access_token"

export async function getRole() {
    await firebaseAuth.auth.authStateReady()

    if (!firebaseAuth.auth.currentUser) {
        return { role: 'anonymous', other_roles: ['anonymous'] }
    }
    const tokenResult = await getIdTokenResult(firebaseAuth.auth.currentUser!);
    logger.debug(tokenResult)

    const customClaims = tokenResult.claims['https://hasura.io/jwt/claims'] as Record<string, string | string[]>
    const role = customClaims['x-hasura-default-role']
    const other_roles = customClaims['x-hasura-allowed-roles'] as string[]

    logger.debug("identity", { role, other_roles })

    return { role, other_roles }
}